import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 96.853 77.483',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      className="icon"
      d="M17.461,20.712l15.452,5.627C38.239,14,45.959,4.5,53.948.053a45.282,45.282,0,0,0-37.61,16.919,2.423,2.423,0,0,0,1.123,3.741ZM37.474,28l36.09,13.14c5.412-18.369,2.83-35.058-6.451-38.435A10.129,10.129,0,0,0,63.618,2.1c-8.78,0-19.411,10.468-26.144,25.9ZM78.917,9.151a34.324,34.324,0,0,1,2,8.352c.869,7.55-.215,16.379-2.868,25.269l15.53,5.654a2.421,2.421,0,0,0,3.264-2.144A45.309,45.309,0,0,0,78.917,9.151Zm5.829,58.638H48.587l9.827-27.01-9.1-3.314L38.281,67.787H2.421A2.421,2.421,0,0,0,0,70.21v4.844a2.422,2.422,0,0,0,2.421,2.423H84.746a2.422,2.422,0,0,0,2.421-2.423V70.21A2.421,2.421,0,0,0,84.746,67.789Z"
      transform="translate(0 0.006)"
      fill={fill}
    />
  </svg>
);

export default SVG;
